import { type FC } from 'react';
import type { DropdownPanelProps } from '../types/findingHierarchy';
import { FindingGridPicker } from '../FindingGridPicker';
import styles from './DropdownPanel.module.css';

const DropdownPanel: FC<DropdownPanelProps> = ({
  open,
  disabled,
  visibleOptions,
  gridRow,
  gridCol,
  setGridPos,
  onSuppressBlur,
  onClearKeyboardNav,
  onSelectLeaf,
  onToggleAllNormal,
  topOffset,
  selectedStatements,
  focusedPillDomRef,
}) => {
  if (!open || disabled) return null;

  return (
    <div
      role="listbox"
      tabIndex={-1}
      onMouseDown={(e) => {
        e.preventDefault();
        onSuppressBlur();
      }}
      onMouseMove={() => {
        onClearKeyboardNav();
      }}
      className={styles.panel}
      style={{ top: topOffset }}
    >
      {visibleOptions.length === 0 ? (
        <div className={styles.emptyState}>No options available</div>
      ) : (
        <FindingGridPicker
          visibleOptions={visibleOptions}
          gridRow={gridRow}
          gridCol={gridCol}
          setGridPos={setGridPos}
          selectedStatements={selectedStatements}
          onSelectLeaf={onSelectLeaf}
          onToggleAllNormal={onToggleAllNormal}
          focusedPillDomRef={focusedPillDomRef}
        />
      )}
    </div>
  );
};

export default DropdownPanel;
